/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_AspNetCore_Mvc_MultiTenancy_FindTenantResultDto } from '../models/Volo_Abp_AspNetCore_Mvc_MultiTenancy_FindTenantResultDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AbpTenantService {

    /**
     * @param name 
     * @returns Volo_Abp_AspNetCore_Mvc_MultiTenancy_FindTenantResultDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAbpMultiTenancyTenantsByName(
name: string,
): CancelablePromise<Volo_Abp_AspNetCore_Mvc_MultiTenancy_FindTenantResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/abp/multi-tenancy/tenants/by-name/{name}',
            path: {
                'name': name,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Volo_Abp_AspNetCore_Mvc_MultiTenancy_FindTenantResultDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAbpMultiTenancyTenantsById(
id: string,
): CancelablePromise<Volo_Abp_AspNetCore_Mvc_MultiTenancy_FindTenantResultDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/abp/multi-tenancy/tenants/by-id/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
